import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  type: "button",
  disabled: ""
}
const _hoisted_8 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_9 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xxl-4 col-xm-12" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col-md-8 col-sm-12 col-lg-8 col-xl-8 col-xxl-8 col-xm-12" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-end pe-0 sm" }
const _hoisted_31 = { class: "dropdown" }
const _hoisted_32 = { class: "dropdown-menu" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_36 = {
  class: "modal fade",
  id: "imageModal",
  tabindex: "-1",
  "aria-labelledby": "imageModalLabel",
  "aria-hidden": "true",
  ref: "modalEl"
}
const _hoisted_37 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_38 = { class: "modal-content" }
const _hoisted_39 = {
  class: "modal-body d-flex justify-content-center align-items-center",
  style: {"min-height":"300px"}
}
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  class: "modal fade",
  id: "voirImageModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "voirImageModal"
}
const _hoisted_42 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_43 = { class: "modal-content" }
const _hoisted_44 = { class: "modal-body d-flex justify-content-center align-items-center" }
const _hoisted_45 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddUsagerModal = _resolveComponent("AddUsagerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.telecharger && _ctx.telecharger(...args))),
                disabled: _ctx.isLoading,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                type: "button"
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "flaticon-download position-relative ms-5 fs-12" }, null, -1)),
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Exporter"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("span", {
                        class: "spinner-grow spinner-grow-sm me-2",
                        role: "status",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode(" Export en cours... ", -1)
                    ]))]))
              ], 8, _hoisted_4))
            : _createCommentVNode("", true),
          (!_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", _hoisted_7, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("span", {
                  class: "spinner-grow spinner-grow-sm",
                  role: "status",
                  "aria-hidden": "true"
                }, null, -1),
                _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.checkPermission('AddUsager'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("a", {
                href: "#",
                "data-bs-toggle": "modal",
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                "data-bs-target": "#AddUsagerModal",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ajouterUsager && _ctx.ajouterUsager(...args))),
                type: "button"
              }, [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Nouvel usager ", -1),
                _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
              ]))])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot clé ", -1)),
                _createVNode(_component_Field, {
                  modelValue: _ctx.motCle,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.motCle) = $event)),
                  name: "mot",
                  type: "text",
                  "aria-disabled": "true",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Recherche par mot clé"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "mot",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Etats ", -1)),
                _createVNode(_component_Field, {
                  name: "etat",
                  modelValue: _ctx.etat,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.etat) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      mode: "tags",
                      options: _ctx.etatsOptions,
                      searchable: true,
                      noResultText: "Aucun enregistrement trouvé",
                      placeholder: "Rechercher par secteur"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "secteur",
                  class: "text-danger"
                })
              ])
            ])
          ])
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("table", _hoisted_17, [
            _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " ### "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " # "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Nom complet "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " NPI "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " IFU "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Sexe "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Téléphone "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Catégorie "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Activité "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Détail "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                }, " Actions ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usagers, (us, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_18, [
                    _createElementVNode("a", {
                      class: "dropdown-item d-flex align-items-center",
                      "data-bs-toggle": "modal",
                      onClick: ($event: any) => (_ctx.handleVoirImage(us.medias)),
                      "data-bs-target": "#voirImageModal",
                      style: {"cursor":"pointer"}
                    }, [
                      ((us.medias && us.medias.length > 0))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.getUrlApiForFiles('Usagers', us.medias[(us.medias.length - 1)].nomMedia),
                            alt: "PhotoUsager",
                            width: "50",
                            height: "50"
                          }, null, 8, _hoisted_20))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_19)
                  ]),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(us.matricule), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(us.full_name), 1),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(us.npi), 1),
                  _createElementVNode("td", _hoisted_24, _toDisplayString(us.ifu), 1),
                  _createElementVNode("td", _hoisted_25, _toDisplayString(us.sexe), 1),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(us.tel), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.afficher20Caracteres(us.activite)), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.afficher20Caracteres(us.new_activite)), 1),
                  _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.afficher20Caracteres(us.nouveau_activite)), 1),
                  _createElementVNode("td", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _cache[13] || (_cache[13] = _createElementVNode("span", {
                        class: "badge text-white bg-secondary fs-15 dropdown-toggle",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createTextVNode(" Actions "),
                        _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_32, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            to: `detail-usager/${us.matricule}`,
                            type: "button",
                            class: "dropdown-item d-flex align-items-center"
                          }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Détails ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "dropdown-item d-flex align-items-center",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#AddUsagerModal",
                            onClick: ($event: any) => (_ctx.modifUsager(us.matricule)),
                            type: "button"
                          }, [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Modifier ", -1)
                          ]))], 8, _hoisted_33)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.getApercu(us)),
                            type: "button",
                            class: "dropdown-item d-flex align-items-center"
                          }, [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Apercu du statut ", -1)
                          ]))], 8, _hoisted_34)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", {
              class: "modal-title",
              id: "imageModalLabel"
            }, "Aperçu de l'image"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("img", {
              src: _ctx.currentImageUrl,
              alt: "Image",
              class: "img-fluid"
            }, null, 8, _hoisted_40)
          ])
        ])
      ])
    ], 512),
    _createVNode(_component_AddUsagerModal, {
      item: _ctx.selectedItem,
      onClose: _ctx.recharger,
      onOpen: _ctx.show_Modal
    }, null, 8, ["item", "onClose", "onOpen"]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Voir image"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_44, [
            (_ctx.currentImageUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.currentImageUrl,
                  alt: "PhotoUsager"
                }, null, 8, _hoisted_45))
              : _createCommentVNode("", true)
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Fermer ")
          ], -1))
        ])
      ])
    ], 512)
  ], 64))
}